<div class="main-container">
  <div class="login-container">
    <div class="login-body">
      <img src="https://re-flow.dk/assets/reflow-newlogo.png" class="logo" alt="Reflow Logo">
      <label class="text-big">Welcome to ReFlow</label>
      <label class="text-medium">Please enter your email to receive a login link</label>
      <form class="login-form" id="loginForm" (ngSubmit)="onSubmit()" #loginForm="ngForm">
        <label class="text-small" for="email">Email</label>
        <br>
        <input 
          type="email" 
          id="email" 
          name="email" 
          class="email-input"
          [(ngModel)]="email" 
          required 
          placeholder="your.email@example.com">
        <button type="submit" class="submit" id="send-link-btn" [disabled]="isSubmitting">
          {{ isSubmitting ? 'Sending...' : 'Send login link' }}
        </button>
      </form>
      
    <div class="message-container">
      <p class="message" [ngClass]="{ 'error': validationError, 'alert-success': successMessage }">
        {{ validationError || successMessage || '\u00A0' }}
      </p>
    </div>

    </div>
    <div class="login-footer">
      <label class="footer-text">
        V2.1 Copyrights © 2025 ReFlow ApS - All rights reserved
      </label>
    </div>
  </div>
  <div class="cover-container"></div>
</div>
